// Unified remove function for both cart and drawer
function removeItem($button) {
  const itemKey = $button.data('id');
  const isDrawer = $button.closest('.mini-cart-items').length > 0;
  
  // Show loading state
  $button.addClass('loading').prop('disabled', true);

  // Use Shopify's native change.js endpoint
  $.ajax({
    url: '/cart/change.js',
    type: 'POST',
    dataType: 'json',
    data: {
      id: itemKey,
      quantity: 0
    },
    success: function(cart) {
      console.log('Removal successful', cart);
      
      // Update UI based on context
      if (isDrawer) {
        // For drawer items
        $button.closest('.ajaxcart__product').fadeOut(300, function() {
          $(this).remove();
          cartData(); // Refresh drawer content
        });
      } else {
        // For cart page items
        $.get('/cart', function(data) {
          const $newCart = $(data).find('.fromcart');
          $('.fromcart').replaceWith($newCart);
        });
      }
      
      // Update cart count everywhere
      $('.cart-count').text(cart.item_count);
    },
    error: function(xhr, status, error) {
      console.error('Removal failed:', error);
      $button.removeClass('loading').prop('disabled', false);
      alert('Failed to remove item. Please try again.');
    }
  });
}

// Event handlers for both contexts
$(document).on('click', '.remove, .remove-product', function(e) {
  e.preventDefault();
  e.stopImmediatePropagation();
  removeItem($(this));
});

function cartData() {
  jQuery.ajax({
    type: "GET",
    url: "/cart?view=drawer-cart",
    dataType: "html",
    success: function (cart) {
      $(".mini-cart-items").html($(cart).find(".drawer_content").html());
      $(".cart-count").html($(cart).find(".cart-count").html());
      setTimeout(function () {
        var btn_h =
          '<a href="#" class="btn btn--secondary btn--full cart__remove_all_wc">Remove All</a>';
        $(".cart-ordernote").prepend(btn_h);
      }, 300);
    },
  });
}

$(window).on("load", function () {
  $(".algolia-autocomplete").insertAfter(".site-header-main");

  /**
   * Module to ajaxify all add to cart forms on the page.
   *
   * Copyright (c) 2015 Caroline Schnapp (11heavens.com)
   * Dual licensed under the MIT and GPL licenses:
   * http://www.opensource.org/licenses/mit-license.php
   * http://www.gnu.org/licenses/gpl.html
   *
   */
  Shopify.AjaxifyCart = (function ($) {
    // Some configuration options.
    // I have separated what you will never need to change from what
    // you might change.

    var _config = {
      // What you might want to change
      addToCartBtnLabel: "Add to cart",
      addedToCartBtnLabel: "Add to cart",
      addingToCartBtnLabel: "Add to cart",
      soldOutBtnLabel: "Sold Out",
      howLongTillBtnReturnsToNormal: 1000, // in milliseconds.
      cartCountSelector:
        ".cart-count, #cart-count a:first, #gocart p a, #cart .checkout em, .item-count",
      cartTotalSelector: "#cart-price",
      // 'aboveForm' for top of add to cart form,
      // 'belowForm' for below the add to cart form, and
      // 'nextButton' for next to add to cart button.
      feedbackPosition: "nextButton",

      // What you will never need to change
      addToCartBtnSelector: '[type="submit"]',
      addToCartFormSelector: 'form[action="/cart/add"]',
      shopifyAjaxAddURL: "/cart/add.js",
      shopifyAjaxCartURL: "/cart.js",
    };

    // We need some feedback when adding an item to the cart.
    // Here it is.
    var _showFeedback = function (success, html, $addToCartForm) {
      $(".ajaxified-cart-feedback").remove();
      var feedback =
        '<p class="ajaxified-cart-feedback ' + success + '">' + html + "</p>";
      switch (_config.feedbackPosition) {
        case "aboveForm":
          $addToCartForm.before(feedback);
          break;
        case "belowForm":
          $addToCartForm.after(feedback);
          break;
        case "nextButton":
        default:
          $addToCartForm.find(_config.addToCartBtnSelector).after(feedback);
          break;
      }
      // If you use animate.css
      // $('.ajaxified-cart-feedback').addClass('animated bounceInDown');
      $(".ajaxified-cart-feedback").slideDown();
    };
    var _setText = function ($button, label) {
      if ($button.children().length) {
        $button.children().each(function () {
          if ($.trim($(this).text()) !== "") {
            $(this).text(label);
          }
        });
      } else {
        $button.val(label).text(label);
      }
    };
    var _init = function () {
      $(document).ready(function () {
        $(_config.addToCartFormSelector).submit(function (e) {
          jsonObj = [];
          keyObj = [];
          var selected_bore;
          e.preventDefault();

          var $addToCartForm = $(this);
          var $addToCartBtn = $addToCartForm.find(_config.addToCartBtnSelector);
          _setText($addToCartBtn, _config.addingToCartBtnLabel);
          $addToCartBtn.addClass("processing").prop("disabled", true);
          // Add to cart.
          var mainid = $addToCartForm.find('[name="id"]').val();
          selected_bore = $(".product-customisation__field select")
            .find("option:selected")
            .val();
            
          console.log('selected_bore:', selected_bore);
          var selected_bore_size = $(".product-customisation__field select")
            .find("option:selected")
            .attr("data-boresize");
          var selected_bore_qty = $(this).find(".form-field-number").val();
          var keyval = $("input[name='properties[Keyway]']:checked").val();
          var setval = $("input[name='properties[Setscrew]']:checked").attr(
            "datid"
          );
          var dateNow = new Date();
          var timestampNow = dateNow.getTime();
          var customid = timestampNow;
          $("#customisation-id").val(customid);
          $(".keyset").each(function () {
            var valcheck = $(this).find("input:checked").val();
            var vall = $(this).find("input:checked").attr("datid");
            if (valcheck == "Yes") {
              sampless = {};
              sampless["id"] = parseInt(vall);
              sampless["quantity"] = selected_bore_qty;
              sampless["properties"] = {
                "Bore Size": selected_bore_size,
                "Customisation ID": customid,
              };
              keyObj.push(sampless);
              console.log(keyObj);
            }
          });

          if (keyObj.length > 0) {
            $.ajax({
              type: "POST",
              url: window.Shopify.routes.root + "cart/add.js",
              data: { items: keyObj },
              dataType: "json",
              async: false,
              success: function (additems) {
                cartData();
                // bundleAddToCart();
              },
            });
          }
          if (selected_bore) {
            var addData = {
              id: selected_bore,
              quantity: selected_bore_qty,
              properties: {
                "Bore Size": selected_bore_size,
                "Customisation ID": customid,
              },
            };
            $.ajax({
              type: "POST",
              url: window.Shopify.routes.root + "cart/add.js",
              data: addData,
              dataType: "json",
              async: false,
              success: function (additems) {
                cartData();
              },
            });
          }
          
          if ($(this).hasClass("simpleproduct")) {
            var maindata = {
              id: mainid,
              quantity: selected_bore_qty,
            };
          } else {
            var maindata = $addToCartForm.serialize();
          }

          $.ajax({
            url: _config.shopifyAjaxAddURL,
            dataType: "json",
            type: "post",
            data: maindata,
            success: function (itemData) {
              $addToCartBtn.addClass("inverted");
              _setText($addToCartBtn, _config.addedToCartBtnLabel);
              _showFeedback("success", "Add To Cart", $addToCartForm);
              window.setTimeout(function () {
                $addToCartBtn
                  .prop("disabled", false)
                  .removeClass("processing")
                  .removeClass("inverted");
                _setText($addToCartBtn, _config.addToCartBtnLabel);
              }, _config.howLongTillBtnReturnsToNormal);
              cartData();
              setTimeout(function () {
                $(".deskaction .cart-action").addClass("show_drawer");
              }, 2000);
            },
            error: function (XMLHttpRequest) {
              var response = eval("(" + XMLHttpRequest.responseText + ")");
              response = response.description;
              if (response.slice(0, 4) === "All ") {
                _showFeedback(
                  "error",
                  response.replace("All 1 ", "All "),
                  $addToCartForm
                );
                $addToCartBtn.prop("disabled", false);
                _setText($addToCartBtn, _config.soldOutBtnLabel);
                $addToCartBtn.prop("disabled", true);
              } else {
                _showFeedback(
                  "error",
                  '<i class="fa fa-warning"></i> ' + response,
                  $addToCartForm
                );
                $addToCartBtn.prop("disabled", false).removeClass("disabled");
                _setText($addToCartBtn, _config.addToCartBtnLabel);
              }
            },
          });
          return false;
        });
      });
    };
    return {
      init: function (params) {
        // Configuration
        params = params || {};
        // Merging with defaults.
        $.extend(_config, params);
        // Action
        $(function () {
          _init();
        });
      },
      getConfig: function () {
        return _config;
      },
    };
  })(jQuery);

  Shopify.AjaxifyCart.init();

  /******* Cart drawer *****/
  $(document).on("click", ".cart-buttons-inner .drawer_check", function () {
    setTimeout(function () {
      window.location.href = "/checkout";
    }, 100);
  });
  $("body").on("click", ".bolton-cart-drawer a", function () {
    if (window.location.href.indexOf("cart") > -1) {
      $(".bolton-cart-drawer").removeClass("show_drawer");
    } else {
      $(".bolton-cart-drawer").toggleClass("show_drawer");
    }
    $(".site-header-account-link").removeClass("show_form");
  });

  $(document).on("click", ".site-header-account-link .linklogin", function () {
    $(".bolton-cart-drawer").removeClass("show_drawer");
    $(".site-header-account-link").toggleClass("show_form");
  });
  $(document).on("click", ".show_reg", function () {
    $(".header_login_sec").fadeOut();
    $(".header_register_sec ").fadeIn();
  });
  $(document).on("click", ".back_login", function () {
    $(".header_login_sec").fadeIn();
    $(".header_register_sec ").fadeOut();
  });

  //   document.addEventListener('click', function handleClickOutsideBox(event) {
  //   const box = document.getElementById('CartDrawer');

  //   if (!box.contains(event.target)) {
  //     box.style.opacity = '0';
  //   }
  // });
  cartData();
});
/******** Plus/minus update *************/
var plusqtyclass;
if ($(window).width() <= 720) {
  plusqtyclass = ".drawer__content .mobile_qty .ajaxcart__qty--plus";
} else {
  plusqtyclass = ".drawer__content .desktop_qty .ajaxcart__qty--plus";
}

$(document).on("click", plusqtyclass, function () {
  var ujsonobj = [];

  var varid = $(this).attr("data-id");
  var cusid = $(this)
    .parents(".deskaction .CartContainer .ajaxcart__product")
    .attr("data-cartitem-customisationid");
  var singleqty = $(this).prev().val();

  $(".deskaction .CartContainer .ajaxcart__product").each(function (i) {
    var dataid = $(this).attr("data-id");
    if (cusid != "") {
      var customid = $(this).attr("data-cartitem-customisationid");
      if (customid == cusid) {
        if ($(window).width() <= 720) {
          var qty = $(
            '.deskaction .ajaxcart__product[data-cartitem-customisationid="' +
              customid +
              '"] .mobile_qty .ajaxcart__qty-num'
          ).val();
        } else {
          var qty = $(
            '.deskaction .ajaxcart__product[data-cartitem-customisationid="' +
              customid +
              '"] .desktop_qty .ajaxcart__qty-num'
          ).val();
        }
        ujsonobj.push(qty);
        console.log("if:" + qty);
      } else {
        if ($(window).width() <= 720) {
          var qty = $(this).find(".mobile_qty .ajaxcart__qty-num").val();
        } else {
          var qty = $(this).find(".desktop_qty .ajaxcart__qty-num").val();
        }
        console.log(qty);
        ujsonobj.push(qty);
      }
    }
    if (cusid == "") {
      if (dataid == varid) {
        if ($(window).width() <= 720) {
          var qty = $(
            '.deskaction .mobile_qty .ajaxcart__qty--plus[data-id="' +
              dataid +
              '"]'
          )
            .prev(".ajaxcart__qty-num")
            .val();
        } else {
          var qty = $(
            '.deskaction .desktop_qty .ajaxcart__qty--plus[data-id="' +
              dataid +
              '"]'
          )
            .prev(".ajaxcart__qty-num")
            .val();
        }
        ujsonobj.push(qty);
        console.log("ifif:" + qty);
      } else {
        if ($(window).width() <= 720) {
          var qty = $(this).find(".mobile_qty .ajaxcart__qty-num").val();
        } else {
          var qty = $(this).find(".desktop_qty .ajaxcart__qty-num").val();
        }
        console.log(qty);
        ujsonobj.push(qty);
      }
    }
  });
  jQuery.post("/cart/update.js", { updates: ujsonobj }).done(
    setTimeout(function () {
      cartData();
    }, 1000)
  );
});
var minusqtyclass;
if ($(window).width() <= 720) {
  minusqtyclass = ".drawer__content .mobile_qty .ajaxcart__qty--minus";
} else {
  minusqtyclass = ".drawer__content .desktop_qty .ajaxcart__qty--minus";
}
$(document).on("click", minusqtyclass, function () {
  var djsonobj = [];
  var varid = $(this).attr("data-id");
  var cusid = $(this)
    .parents(".deskaction .CartContainer .ajaxcart__product")
    .attr("data-cartitem-customisationid");
  var singleqty = $(this).next().val();
  $(".deskaction .CartContainer .ajaxcart__product").each(function (i) {
    var dataid = $(this).attr("data-id");
    if (cusid != "") {
      var customid = $(this).attr("data-cartitem-customisationid");
      if (customid == cusid) {
        if ($(window).width() <= 720) {
          var qty = $(
            '.deskaction .ajaxcart__product[data-cartitem-customisationid="' +
              customid +
              '"] .mobile_qty .ajaxcart__qty-num'
          ).val();
        } else {
          var qty = $(
            '.deskaction .ajaxcart__product[data-cartitem-customisationid="' +
              customid +
              '"] .desktop_qty .ajaxcart__qty-num'
          ).val();
        }
        djsonobj.push(qty);
        console.log("if:" + qty);
      } else {
        if ($(window).width() <= 720) {
          var qty = $(this).find(".mobile_qty .ajaxcart__qty-num").val();
        } else {
          var qty = $(this).find(".desktop_qty .ajaxcart__qty-num").val();
        }
        console.log(qty);
        djsonobj.push(qty);
      }
    }

    if (cusid == "") {
      if (dataid == varid) {
        if ($(window).width() <= 720) {
          var qty = $(
            '.deskaction .mobile_qty .ajaxcart__qty--minus[data-id="' +
              dataid +
              '"]'
          )
            .next(".ajaxcart__qty-num")
            .val();
        } else {
          var qty = $(
            '.deskaction .desktop_qty .ajaxcart__qty--minus[data-id="' +
              dataid +
              '"]'
          )
            .next(".ajaxcart__qty-num")
            .val();
        }
        djsonobj.push(qty);
        console.log("ifif:" + qty);
      } else {
        if ($(window).width() <= 720) {
          var qty = $(this).find(".mobile_qty .ajaxcart__qty-num").val();
        } else {
          var qty = $(this).find(".desktop_qty .ajaxcart__qty-num").val();
        }
        console.log(qty);
        djsonobj.push(qty);
      }
    }
  });
  jQuery.post("/cart/update.js", { updates: djsonobj }).done(
    setTimeout(function () {
      cartData();
    }, 1000)
  );
});

// /**** cart page plus minus *******************/
var cplusqtyclass;
if ($(window).width() <= 641) {
  cplusqtyclass = ".fromcart .cart-qty-mobile .ajaxcart__qty--plus";
} else {
  cplusqtyclass = ".fromcart .cart-qty-desktop .ajaxcart__qty--plus";
}
$(document).on("click", cplusqtyclass, function () {
  var ujsonobj = [];

  var varid = $(this).attr("data-id");
  var cusid = $(this)
    .parents(".fromcart .ajaxcart__product")
    .attr("data-cartitem-customisationid");
  $(".fromcart .ajaxcart__product").each(function (i) {
    var dataid = $(this).attr("data-id");
    if (cusid != "") {
      var customid = $(this).attr("data-cartitem-customisationid");
      if (customid == cusid) {
        if ($(window).width() <= 641) {
          var qty = $(
            '.fromcart .ajaxcart__product[data-cartitem-customisationid="' +
              customid +
              '"] .cart-qty-mobile .ajaxcart__qty-num'
          ).val();
        } else {
          var qty = $(
            '.fromcart .ajaxcart__product[data-cartitem-customisationid="' +
              customid +
              '"] .cart-qty-desktop .ajaxcart__qty-num'
          ).val();
        }
        ujsonobj.push(qty);
        console.log("if:" + qty);
      } else {
        if ($(window).width() <= 641) {
          var qty = $(this).find(".cart-qty-mobile .ajaxcart__qty-num").val();
        } else {
          var qty = $(this).find(".cart-qty-desktop .ajaxcart__qty-num").val();
        }
        console.log(qty);
        ujsonobj.push(qty);
      }
    }
    if (cusid == "") {
      if (dataid == varid) {
        if ($(window).width() <= 641) {
          var qty = $(
            '.fromcart .cart-qty-mobile .ajaxcart__qty--plus[data-id="' +
              dataid +
              '"]'
          )
            .prev(".ajaxcart__qty-num")
            .val();
        } else {
          var qty = $(
            '.fromcart .cart-qty-desktop .ajaxcart__qty--plus[data-id="' +
              dataid +
              '"]'
          )
            .prev(".ajaxcart__qty-num")
            .val();
        }
        ujsonobj.push(qty);
        console.log("ifif:" + qty);
      } else {
        if ($(window).width() <= 641) {
          var qty = $(this).find(".cart-qty-mobile .ajaxcart__qty-num").val();
        } else {
          var qty = $(this).find(".cart-qty-desktop .ajaxcart__qty-num").val();
        }
        console.log(qty);
        ujsonobj.push(qty);
      }
    }
  });
  jQuery.post("/cart/update.js", { updates: ujsonobj }).done(
    setTimeout(function () {
      jQuery.ajax({
        type: "GET",
        url: "/cart",
        dataType: "html",
        success: function (cart) {
          $(".fromcart").html($(cart).find(".fromcart").html());
          $(".cart-count").html($(cart).find(".cart-count").html());
        },
      });
    }, 1000)
  );
});

var cminusqtyclass;
if ($(window).width() <= 641) {
  cminusqtyclass = ".fromcart .cart-qty-mobile .ajaxcart__qty--minus";
} else {
  cminusqtyclass = ".fromcart .cart-qty-desktop .ajaxcart__qty--minus";
}
$(document).on("click", cminusqtyclass, function () {
  var djsonobj = [];

  var varid = $(this).attr("data-id");
  var cusid = $(this)
    .parents(".fromcart .ajaxcart__product")
    .attr("data-cartitem-customisationid");
  $(".fromcart .ajaxcart__product").each(function (i) {
    var dataid = $(this).attr("data-id");
    if (cusid != "") {
      var customid = $(this).attr("data-cartitem-customisationid");
      if (customid == cusid) {
        if ($(window).width() <= 641) {
          var qty = $(
            '.fromcart .ajaxcart__product[data-cartitem-customisationid="' +
              customid +
              '"] .cart-qty-mobile .ajaxcart__qty-num'
          ).val();
        } else {
          var qty = $(
            '.fromcart .ajaxcart__product[data-cartitem-customisationid="' +
              customid +
              '"] .cart-qty-desktop .ajaxcart__qty-num'
          ).val();
        }
        djsonobj.push(qty);
        console.log("if:" + qty);
      } else {
        if ($(window).width() <= 641) {
          var qty = $(this).find(".cart-qty-mobile .ajaxcart__qty-num").val();
        } else {
          var qty = $(this).find(".cart-qty-desktop .ajaxcart__qty-num").val();
        }
        console.log(qty);
        djsonobj.push(qty);
      }
    }
    if (cusid == "") {
      if (dataid == varid) {
        if ($(window).width() <= 641) {
          var qty = $(
            '.fromcart .cart-qty-mobile .ajaxcart__qty--minus[data-id="' +
              dataid +
              '"]'
          )
            .next(".ajaxcart__qty-num")
            .val();
        } else {
          var qty = $(
            '.fromcart .cart-qty-desktop .ajaxcart__qty--minus[data-id="' +
              dataid +
              '"]'
          )
            .next(".ajaxcart__qty-num")
            .val();
        }
        djsonobj.push(qty);
        console.log("ifif:" + qty);
      } else {
        if ($(window).width() <= 641) {
          var qty = $(this).find(".cart-qty-mobile .ajaxcart__qty-num").val();
        } else {
          var qty = $(this).find(".cart-qty-desktop .ajaxcart__qty-num").val();
        }
        console.log(qty);
        djsonobj.push(qty);
      }
    }
  });
  jQuery.post("/cart/update.js", { updates: djsonobj }).done(
    setTimeout(function () {
      jQuery.ajax({
        type: "GET",
        url: "/cart",
        dataType: "html",
        success: function (cart) {
          $(".fromcart").html($(cart).find(".fromcart").html());
          $(".cart-count").html($(cart).find(".cart-count").html());
        },
      });
    }, 1000)
  );
});

/**********Related Products *******************/
$(document).ready(function () {
$(".relatedProd  select").on("change", function (e) {
  var optionSelected = $("option:selected", this);
  var valueSelected = this.value;
  $(this)
    .parents(".relatedProd")
    .find(".relatedAddToCart")
    .attr("data-add-id", valueSelected);
});
});

$(document).on("click", ".relatedAddToCart", function () {
  var vid = $(this).attr("data-add-id");
  var addData = {
    id: vid,
    quantity: 1,
  };

  var curr = $(this);
  curr.addClass("processing").prop("disabled", true);

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: addData,
    dataType: "json",
    async: false,
    success: function (additems) {
      cartData();

      setTimeout(function () {
        $(".deskaction .cart-action").addClass("show_drawer");
        curr.removeClass("processing").prop("disabled", false);
      }, 2000);
    },
  });
});

/**** Remove button cart drawer****/

var removeclass;
if ($(window).width() <= 720) {
  removeclass = ".drawer__content .mobile_qty .remove";
} else {
  removeclass = ".drawer__content .desktop_qty .remove";
}

$(document).on("click", removeclass, function () {
  var ujsonobj = [];

  var varid = $(this).attr("data-id");
  var cusid = $(this)
    .parents(".deskaction .CartContainer .ajaxcart__product")
    .attr("data-cartitem-customisationid");

  $(".deskaction .CartContainer .ajaxcart__product").each(function (i) {
    var dataid = $(this).attr("data-id");
    if (cusid != "") {
      var customid = $(this).attr("data-cartitem-customisationid");
      if (customid == cusid) {
        if ($(window).width() <= 720) {
          var qty = 0;
        } else {
          var qty = 0;
        }
        ujsonobj.push(qty);
        console.log("if:" + qty);
      } else {
        if ($(window).width() <= 720) {
          var qty = $(this).find(".mobile_qty .ajaxcart__qty-num").val();
        } else {
          var qty = $(this).find(".desktop_qty .ajaxcart__qty-num").val();
        }
        console.log(qty);
        ujsonobj.push(qty);
      }
    }
    if (cusid == "") {
      if (dataid == varid) {
        if ($(window).width() <= 720) {
          var qty = 0;
        } else {
          var qty = 0;
        }
        ujsonobj.push(qty);
        console.log("ifif:" + qty);
      } else {
        if ($(window).width() <= 720) {
          var qty = $(this).find(".mobile_qty .ajaxcart__qty-num").val();
        } else {
          var qty = $(this).find(".desktop_qty .ajaxcart__qty-num").val();
        }
        console.log(qty);
        ujsonobj.push(qty);
      }
    }
  });
  jQuery.post("/cart/update.js", { updates: ujsonobj }).done(
    setTimeout(function () {
      cartData();
    }, 1000)
  );
});

/**** Remove button cart page****/

var cremoveclass;
if ($(window).width() <= 641) {
  cremoveclass = ".cart-qty-mobile .remove-product";
} else {
  cremoveclass = ".cart-qty-desktop .remove-product";
}

$(document).on("click", cremoveclass, function () {
  var ujsonobj = [];

  var varid = $(this).attr("data-id");
  var cusid = $(this)
    .parents(".fromcart .ajaxcart__product")
    .attr("data-cartitem-customisationid");
  $(".fromcart .ajaxcart__product").each(function (i) {
    var dataid = $(this).attr("data-id");
    if (cusid != "") {
      var customid = $(this).attr("data-cartitem-customisationid");
      if (customid == cusid) {
        if ($(window).width() <= 641) {
          var qty = 0;
        } else {
          var qty = 0;
        }
        ujsonobj.push(qty);
        console.log("if:" + qty);
      } else {
        if ($(window).width() <= 641) {
          var qty = $(this).find(".cart-qty-mobile .ajaxcart__qty-num").val();
        } else {
          var qty = $(this).find(".cart-qty-desktop .ajaxcart__qty-num").val();
        }
        console.log(qty);
        ujsonobj.push(qty);
      }
    }
    if (cusid == "") {
      if (dataid == varid) {
        if ($(window).width() <= 641) {
          var qty = 0;
        } else {
          var qty = 0;
        }
        ujsonobj.push(qty);
        console.log("ifif:" + qty);
      } else {
        if ($(window).width() <= 641) {
          var qty = $(this).find(".cart-qty-mobile .ajaxcart__qty-num").val();
        } else {
          var qty = $(this).find(".cart-qty-desktop .ajaxcart__qty-num").val();
        }
        console.log(qty);
        ujsonobj.push(qty);
      }
    }
  });
  jQuery.post("/cart/update.js", { updates: ujsonobj }).done(
    setTimeout(function () {
      jQuery.ajax({
        type: "GET",
        url: "/cart",
        dataType: "html",
        success: function (cart) {
          $(".fromcart").html($(cart).find(".fromcart").html());
          $(".cart-count").html($(cart).find(".cart-count").html());
        },
      });
    }, 1000)
  );
});

$(document).ready(function () {
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $("#scroll").fadeIn();
    } else {
      $("#scroll").fadeOut();
    }
  });
  $("#scroll").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });
});

$(".site-header__cart-toggle").click(function (e) {
  e.preventDefault();
  $(".cart-action").toggleClass("show_drawer");
  $("body").toggleClass("show_drawer_body");
  return false;
});

$(document).mouseup(function (e) {
  if ($(e.target).closest(".mini-cart-items").length === 0) {
    $(".bolton-cart-drawer").removeClass("show_drawer");
  }
  if ($(e.target).closest(".algolia-autocomplete").length === 0) {
    $(".algolia-autocomplete").hide();
    $(".aa-input").val("").removeClass("form-field-filled");
  }
});

$(document).ready(function () {
  $(".inquiry-button .btn").on("click", function () {
    var productTitle = $(this).data("title");
    $("#contact_productTitle").val(productTitle);
  });

  $(".collection--description .read-more").click(function () {
    $(".collection--description-short").toggle();
    $(".collection--description-long").toggle();
  });
});




$(document).ready(function () {


  $(".contact-form-popup .call-icon").click(function(){
    $(".contact-form-popup, .call-icon-with-text .help-text").addClass("open");  // Show the form with smooth transition
  });

  $(".contact-form-popup .cross-icon .icon").click(function(){
    $(".contact-form-popup").removeClass("open");  // Hide the form with smooth transition
  });

  $(".call-icon-with-text .help-text .icon").click(function(){
    $(".call-icon-with-text .help-text").addClass("open");  // Show the form with smooth transition
  });



  // Tab click handler
  $(".custom_tabs .tab").on("click", function (evt) {
    evt.preventDefault();
    $(".custom_tabs .tab").removeClass("active"); // Remove active from all tabs
    $(this).addClass("active"); // Add active to the clicked tab
    var sel = this.getAttribute("data-toggle-target");
    $(".custom_faqs_tabs .tab-content")
      .removeClass("active")
      .filter(sel)
      .addClass("active");
  });

  // Question click handler
  $(".tab-content .question").on("click", function () {
    var $answer = $(this).next(".answer"); // Select the answer associated with the clicked question
    var $contentWrap = $(this).closest(".content-wrap"); // Select the parent content-wrap div

    if ($answer.is(":visible")) {
      // If the answer is visible, slide it up and remove the 'open' class
      $answer.slideUp();
      $contentWrap.removeClass("open");
    } else {
      // Otherwise, slide it down and add the 'open' class
      $answer.slideDown();
      $contentWrap.addClass("open");
    }
  });



   $('.cart-shipping-toggle').click(function(){
        $('#shipping-calculator').slideToggle();
    });

});

//surcharge fee

// async function surchargeFee() {
//     const surchargeProduct = await (await fetch("/products/surcharge.json")).json();
//     const matchingVariant = surchargeProduct.product.variants[0].id;

//     await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//             id: matchingVariant,
//             quantity: 1
//         })
//     });
// }
// console.log(document.querySelector("#surchargeCheckbox"));
// document.querySelector("#surchargeCheckbox").addEventListener("change", async (event) => {
//     if (event.target.checked) {
//         await surchargeFee();
//         location.reload(); 
//     }
// });



